import React from 'react';
import BoostedComponent from './BoostedComponent'

class TimeInput extends BoostedComponent {
    constructor (props) {
        super(props)
        this.state = {
            value: this.props.value ? this.props.value : ""
        }
    }
    componentDidUpdate (prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({
                value: this.props.value ? this.props.value : "00:00"
            })
        }
    }
    handleTimeBlur = (event)=> {
        let value =  event.target.value;

        let heure = value.replace(/\D/g,'')+"00000";
        if (value.substr(0,2).length === 1) {
            heure = "0"+heure
        }
        let debut = heure.substr(0,2);
        let fin = heure.substr(2,2);

        if (parseInt(debut, 10) > 23) {
            debut = "0"+value.substr(0,1);
            fin = value.substr(1,2);
        } else if (parseInt(debut, 10) > 23) debut = ("00"+(debut%24)).substr(-2,2);

        
        value = debut+":"+fin;

        this.setState({
            value: value
        });

        event.target.value = value;
        if (this.props.onChange) this.props.onChange(event)
    }
    handleTimeChange  = (event) => {
        let heure = event.target.value.replace(/\D/g,'')+"";
        let debut = heure.substr(0,2);
        let fin = heure.substr(2,2);
        if (parseInt(debut, 10) > 23 && heure.length < 4) {
            debut = "0"+heure.substr(0,1);
            fin = heure.substr(1,2);
        } else if (parseInt(debut, 10) > 23) debut = ("00"+(debut%24)).substr(-2,2);

        if (parseInt(fin, 10) > 59 ) fin = ("00"+(fin%60)).substr(-2,2);
        if (heure.length > 2) {
            heure = debut+":"+fin;
        }
        this.setState({
            value: heure
        });
    }

    render() {
        return(
                <input onKeyDown={(e)=>{
                    if (e.keyCode === 13) {
                    e.target.blur()
                    }
                }} type="text" value={this.state.value} onChange={this.handleTimeChange} onBlur={this.handleTimeBlur } />
        )
    }
}
export default TimeInput;



// WEBPACK FOOTER //
// ./src/TimeInput.js